//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MenuIcon from 'vue-material-design-icons/Menu'
import {updateUrl} from '../utils'

export default {
  name: 'NavBar',
  props: {
    menu: {
      type: Object,
      default: () => ({}),
    },
    apps: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    MenuIcon,
  },
  data() {
    return {
      hamburgerIsActive: false,
      currentPath: ''
    };
  },
  computed: {
    mainMenu() {
      return this.menu && this.menu.list;
    },
    hamburgerMenu() {
      return this.menu && this.menu.hamburger;
    },
  },
  mounted() {
    window.addEventListener('single-spa:app-change', () => {
      this.updatePath()
    });
  },
  methods: {
    updatePath() {
      this.currentPath = location.pathname
    },
    toggleHamburgerActivity() {
      this.hamburgerIsActive = !this.hamburgerIsActive;
    },
    menuClick(item) {
      this.hamburgerIsActive = false;
      if (item.application === 'mb-app-iframe-viewer') {
        this.$router.push(`/pages${item.path}`).catch(()=>{})
      } else if (item.path === '/issuers/info') {
        window.location.pathname = item.path;
      } else {
        this.$router.push(item.path).catch(()=>{})
      }
      updateUrl(this.$i18n)
    },
  }
}
